import {
  GET_ACCOUNTING_DATA_REQUEST,
  GET_ACCOUNTING_DATA_SUCCESS,
  GET_ACCOUNTING_DATA_FAILURE,
  GET_ACCOUNTING_SUMMARY_REQUEST,
  GET_ACCOUNTING_SUMMARY_SUCCESS,
  GET_ACCOUNTING_SUMMARY_FAILURE,
  UPDATE_PAYMENT_RECEIVED_REQUEST,
  UPDATE_PAYMENT_RECEIVED_SUCCESS,
  UPDATE_PAYMENT_RECEIVED_FAILURE,
  GET_ACCOUNTING_DATA_FOR_EXPORT_REQUEST,
  GET_ACCOUNTING_DATA_FOR_EXPORT_SUCCESS,
  GET_ACCOUNTING_DATA_FOR_EXPORT_FAILURE,
} from '../constants/actionTypes'

const initialState = {
  data: [],
  total: 0,
  summary: {},
  isFetching: false,
  isUpdatingPayment: false,
  errorMessage: '',
}

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ACCOUNTING_DATA_REQUEST:
      return {
        ...state,
        errorMessage: '',
        isFetching: action.isFetching,
      }
    case GET_ACCOUNTING_DATA_SUCCESS:
      return {
        ...state,
        data: action.data,
        isFetching: action.isFetching,
      }
    case GET_ACCOUNTING_DATA_FAILURE:
      return {
        ...state,
        errorMessage: action.message,
        isFetching: action.isFetching,
      }
    case GET_ACCOUNTING_DATA_FOR_EXPORT_REQUEST:
      return {
        ...state,
        errorMessage: '',
        isFetching: action.isFetching,
      }
    case GET_ACCOUNTING_DATA_FOR_EXPORT_SUCCESS:
      return {
        ...state,
        data: action.data,
        isFetching: action.isFetching,
      }
    case GET_ACCOUNTING_DATA_FOR_EXPORT_FAILURE:
      return {
        ...state,
        errorMessage: action.message,
        isFetching: action.isFetching,
      }
    case GET_ACCOUNTING_SUMMARY_REQUEST:
      return {
        ...state,
        errorMessage: '',
      }
    case GET_ACCOUNTING_SUMMARY_SUCCESS:
      return {
        ...state,
        summary: action.result,
      }
    case GET_ACCOUNTING_SUMMARY_FAILURE:
      return {
        ...state,
        errorMessage: action.message,
      }
    default:
      return state
  }
}
